import { useBasket } from "./useBasket";
import { useCurrentBasketId } from "./useCurrentBasketId";

interface Props {
  idGenerationEnabled?: boolean;
}

export const useCurrentBasket = (config?: Props) => {
  const { currentBasketId, setCurrentBasketId } = useCurrentBasketId(config);
  const basketHook = useBasket(currentBasketId);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { basket: currentBasket, ...basketHookWithoutBasket } = basketHook;

  return {
    ...basketHookWithoutBasket,
    currentBasket,
    setCurrentBasketId,
    currentBasketId,
  };
};
